import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import VacancyCard from 'components/VacancyCard';
import Button from 'components/Button';
import OnScreen from 'components/OnScreen';

import css from './VacancyListBlock.module.scss';

import { THEMES, getThemeClassNames } from 'constants/themes';

const VacancyListBlock = ({
    blockId,
    heading,
    onScreen,
    vacancies,
    link,
    linkText,
    theme,
    displayImages,
    totalCount,
}) => (
    <div
        className={cn(css.block, getThemeClassNames(css, theme))}
        data-block={blockId}
        tabIndex="-1"
    >
        <div className={css.content}>
            {typeof totalCount !== "undefined" &&
                ((totalCount === -1 && heading && (
                    <h2
                        className={cn("h1", css.heading)}
                        dangerouslySetInnerHTML={{__html: heading }}
                    />
                )) ||
                (totalCount !== -1 && (
                    <h2 className={cn("h1", css.heading)}>
                        <strong>{totalCount}</strong> {heading}
                    </h2>
                )))
            }
            <ul>
                {vacancies && vacancies.map(v => (
                    <li key={v.id} className={cn({ [css["is-on-screen"]] : onScreen })}>
                        <VacancyCard
                            {...v}
                            onScreen={onScreen}
                            displayImage={displayImages}
                        />
                    </li>
                ))}
            </ul>
            {link && (
                <div className={css['see-all']}>
                    <Button href={link}>{linkText}</Button>
                </div>
            )}
        </div>
    </div>
);

VacancyListBlock.defaultProps = {
    theme: 1, // default yellow,
    displayImages: true,
};

VacancyListBlock.propTypes = {
    blockId: PropTypes.number,
    heading: PropTypes.string,
    totalCount: PropTypes.number,
    onScreen: PropTypes.bool,
    vacancies: PropTypes.array.isRequired,
    link: PropTypes.string,
    linkText: PropTypes.string,
    theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
    displayImages: PropTypes.bool.isRequired,
};

export default OnScreen(VacancyListBlock);



// WEBPACK FOOTER //
// ./src/components/VacancyListBlock/VacancyListBlock.jsx